import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import logo from '../../logo.svg';
import lock from '../../assets/img/Lock.svg';
import eye from '../../assets/img/eye-off.svg';

export default function ResetPassword() {
    const { t } = useTranslation();
    const { token } = useParams();

    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [passwordShown, setPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const password = event.target.password.value;
        const confirmPassword = event.target.confirmPassword.value;

        if (password !== confirmPassword) {
            setError(t('Passwords do not match'));
            return;
        }

        setError('');
        setSubmitting(true);

        fetch(import.meta.env.VITE_API_URL + '/v1/user/reset-password', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, password })
        })
            .then(response => response.json())
            .then(data => {
                setSubmitting(false);
                if (data.status === 'ok') {
                    setSuccess(true);
                } else {
                    setError(data.error || t('An error occurred. Please try again.'));
                }
            })
            .catch(() => {
                setSubmitting(false);
                setError(t('An error occurred. Please try again.'));
            });
    };

    return (
        <>
            <div className="red-background"></div>
            <div className="login-container">
                <div className="logo">
                    <img alt="Task-Gen" src={logo} />
                </div>
                <div className="login-email">
                    {!success && (
                        <Form className="form-login" onSubmit={handleSubmit}>
                            <p>{t('Reset your password')}</p>
                            <div className="field">
                                <div className="password">
                                    <img src={lock} alt="" />
                                    <input
                                        name="password"
                                        type={passwordShown ? 'text' : 'password'}
                                        placeholder={t('New password')}
                                        required
                                    />
                                    <a
                                        onClick={() => setPasswordShown(!passwordShown)}
                                        className={passwordShown ? 'hide-pass' : 'show-pass'}
                                    >
                                        <img src={eye} alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="field">
                                <div className="password">
                                    <img src={lock} alt="" />
                                    <input
                                        name="confirmPassword"
                                        type={confirmPasswordShown ? 'text' : 'password'}
                                        placeholder={t('Confirm password')}
                                        required
                                    />
                                    <a
                                        onClick={() => setConfirmPasswordShown(!confirmPasswordShown)}
                                        className={confirmPasswordShown ? 'hide-pass' : 'show-pass'}
                                    >
                                        <img src={eye} alt="" />
                                    </a>
                                </div>
                            </div>
                            {error && <p className="text-danger">{error}</p>}
                            <div className="actions">
                                <input
                                    className="submit btn btn-primary"
                                    type="submit"
                                    value={t('Update password')}
                                    disabled={submitting}
                                />
                            </div>
                            {submitting && (
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">{t('Loading...')}</span>
                                </Spinner>
                            )}
                        </Form>
                    )}

                    {success && (
                        <div className="text-center">
                            <p>{t('Password updated successfully.')}</p>
                            <a href="#/" className="btn btn-primary">{t('Back to login')}</a>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
